<script setup lang="ts">
import checkpointApi from '@/services/checkpoint.service'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import { ECheckpointsPerm } from '@/types/permissions/CheckpointsPermissionsEnum'
import { DeleteButton, PermissionWrapper, StackLayout } from '@rfc/rfc-components-library'
import type { DeleteButtonConfirmationDialog } from '@rfc/rfc-components-library/types'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const route = useRoute()
const { t } = useI18n()
const eventId = computed(() => parseInt(route.params.event_id.toString()))

type Props = {
    device: AssociatedDeviceModel
    checkpointId?: number
}
const props = defineProps<Props>()
const emit = defineEmits<{ (e: 'refresh'): void }>()

const dissociateDevice = () => {
    if (!props.checkpointId) return
    checkpointApi
        .unassociateDeviceFromCheckpoint(eventId.value, props.checkpointId, props.device.device_id)
        .then(() => emit('refresh'))
}

const confirmationDialog: DeleteButtonConfirmationDialog = {
    title: t('checkpoint.detail.dissociateDevice'),
    contentText: t('checkpoint.detail.dissociateDeviceContent')
}
</script>

<template>
    <StackLayout gap="16" class="dissociate-device-card pl-5 pr-2 py-2 items-center border-dashed">
        {{ device.name }}
        <PermissionWrapper :permission="ECheckpointsPerm.CHECKPOINTS_EDIT">
            <DeleteButton
                class="w-full dissociate-button"
                :confirmationDialog="confirmationDialog"
                onlyIcon
                @click="dissociateDevice" />
        </PermissionWrapper>
    </StackLayout>
</template>

<style scoped lang="scss">
.dissociate-device-card {
    border: 1px solid rgba(var(--v-theme-primary));
    border-radius: 30px;
}
.dissociate-button {
    &:deep(span) {
        display: flex;
        flex-direction: row;
        gap: 8px;
    }
}
</style>
